import { HttpClient } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { environment } from 'src/environments/environment';

import Swiper from 'swiper';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import type { SwiperOptions } from 'swiper/types';
 Swiper.use([Autoplay, Pagination, Navigation]);


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent {

  baseUrl = environment.apiBaseUrl;


  // images: GalleryImage[] = [];
  images: any[] = [];


  currentSlide: number = 0;
  slideInterval: any;

  selectedImage: string | null = null;

   constructor(private http: HttpClient) {}

  openImage(img: string): void {
    this.selectedImage = img;
  }

  closeImage(): void {
    this.selectedImage = null;
  }

swiperConfig: SwiperOptions = {
  slidesPerView: 5,
  spaceBetween: 20,
  loop: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false
  },
  pagination: {
    clickable: true
  },
  navigation: true,
};

slidePosition = 0;  // موقعیت اسلاید برای حرکت تصاویر
  dragStart = 0;  // موقعیت شروع کشیدن
  isDragging = false;  // وضعیت کشیدن فعال



  ngOnInit(): void {
    // this.startAutoSlide();

    this.loadImages();
    this.slideInterval = setInterval(() => {
      this.nextSlide();
    }, 5000); // تغییر هر 5 ثانیه
  }


ngOnDestroy(): void {
  clearInterval(this.slideInterval);
}

nextSlide(): void {
  this.currentSlide = (this.currentSlide + 1) % this.images.length;
   this.updateSlidePosition();
}

previousSlide(): void {
    this.currentSlide = (this.currentSlide - 1 + this.images.length) % this.images.length;
    this.updateSlidePosition();
  }

 updateSlidePosition(): void {
  // به جای 33.333 از 100 استفاده کنید تا هر اسلاید دقیقا جای اسلاید قبلی را بگیرد
  this.slidePosition = -this.currentSlide * 100;
}
 selectThumbnail(imageUrl: string): void {
    this.openImage(imageUrl); // مطمئن شوید که URL کامل است
    // همچنین می‌توانید اینجا اسلایدر اصلی را به عکس مورد نظر ببرید
    // این بستگی به منطق دقیق شما دارد
  }

    // تابعی برای کلیک روی عکس در اسلایدر اصلی
  openImageFromSlider(imageUrl: string): void {
    this.openImage(imageUrl);
  }


  onMouseDown(event: MouseEvent): void {
    this.isDragging = true;
    this.dragStart = event.clientX;
  }

  onMouseMove(event: MouseEvent): void {
    if (this.isDragging) {
      const dragOffset = this.dragStart - event.clientX;
      this.slidePosition -= dragOffset * 0.2; // تغییرات کشیدن را کنترل می‌کند
      this.dragStart = event.clientX;
    }
  }

  onMouseUp(): void {
    this.isDragging = false;
  }

  onMouseLeave(): void {
    this.isDragging = false;
  }
// return this.http.get(`${this.baseUrl}/data`);
  loadImages(): void {
    this.http.get<any[]>(`${this.baseUrl}/home`).subscribe((res) => {
      this.images = res;
    });
  }

  // ngOnDestroy(): void {
  //   if (this.slideInterval) {
  //     clearInterval(this.slideInterval);
  //   }

  // }


  currentOffset: number = 0;





}
